import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  Button, 
} from '@material-ui/core';

// >> redux
// import {
//   setAddressDBChecks
// } from '../../../../../redux/actions/addressdbs';
// <<

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 600
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const AddressDBTable = props => {
  const { className, addressdbs, onSetSelectedAddressDBs, ...rest } = props;

  const classes = useStyles();

  const [selectedAddressDBs, setSelectedAddressDBs] = useState([]);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [page, setPage] = useState(0);

  const handleSelectAll = event => {

    let selectedAddressDBs;

    if (event.target.checked) {
      selectedAddressDBs = addressdbs.map(addressdb => addressdb.id);
    } else {
      selectedAddressDBs = [];
    }

    setSelectedAddressDBs(selectedAddressDBs);
    onSetSelectedAddressDBs(selectedAddressDBs);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedAddressDBs.indexOf(id);
    let newSelectedAddressDBs = [];

    if (selectedIndex === -1) {
      newSelectedAddressDBs = newSelectedAddressDBs.concat(selectedAddressDBs, id);
    } else if (selectedIndex === 0) {
      newSelectedAddressDBs = newSelectedAddressDBs.concat(selectedAddressDBs.slice(1));
    } else if (selectedIndex === selectedAddressDBs.length - 1) {
      newSelectedAddressDBs = newSelectedAddressDBs.concat(selectedAddressDBs.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedAddressDBs = newSelectedAddressDBs.concat(
        selectedAddressDBs.slice(0, selectedIndex),
        selectedAddressDBs.slice(selectedIndex + 1)
      );
    }

    setSelectedAddressDBs(newSelectedAddressDBs);
    onSetSelectedAddressDBs(newSelectedAddressDBs);
  };

  useEffect(() => {
    //console.log('componentDidUpdate & addressdbs changed' + addressdbs);

    const newSelected = selectedAddressDBs.filter(id => {
      const findObj = addressdbs.find(obj => obj.id == id);
      return findObj !== undefined && findObj !== null;
    });

    setSelectedAddressDBs(newSelected);
    onSetSelectedAddressDBs(newSelected);

  }, [addressdbs]);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedAddressDBs.length > 0 && selectedAddressDBs.length === addressdbs.length}
                      color="primary"
                      indeterminate={
                        selectedAddressDBs.length > 0 &&
                        selectedAddressDBs.length < addressdbs.length
                      }
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                  <TableCell>번호</TableCell>
                  <TableCell>DB명</TableCell>
                  <TableCell>수정자</TableCell>
                  <TableCell>수정일</TableCell>
                  <TableCell>설명</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {addressdbs.map((addressdb, index) => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={addressdb.id}
                    selected={selectedAddressDBs.indexOf(addressdb.id) !== -1}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedAddressDBs.indexOf(addressdb.id) !== -1}
                        color="primary"
                        onChange={event => handleSelectOne(event, addressdb.id)}
                        value="true"
                      />
                    </TableCell>
                    <TableCell>{index}</TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        {/* <Avatar
                          className={classes.avatar}
                          src={category.avatarUrl}
                        >
                          {getInitials(category.name)}
                        </Avatar> */}
                        <Typography variant="body1">{addressdb.name}</Typography>
                      </div>
                    </TableCell>
                    <TableCell>{addressdb.modified_user}</TableCell>
                    <TableCell>
                      {moment(addressdb.modified_at).format('YYYY-MM-DD')}
                    </TableCell>
                    <TableCell>{addressdb.description ? addressdb.description : ''}</TableCell>
                    {/* <TableCell>{category.email}</TableCell>
                    <TableCell>
                      {category.address.city}, {category.address.state},{' '}
                      {category.address.country}
                    </TableCell>
                    <TableCell>{category.phone}</TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      {/* <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={categories.length}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions> */}
    </Card>
  );
};

AddressDBTable.propTypes = {
  className: PropTypes.string,
  addressdbs: PropTypes.array.isRequired
};

// //export default CategoryTable;

// const mapStateToProps = state => ({
//   addressdbs: state.addressdbs.addressdbsList
// });

// const mapDispatchToProps = dispatch => ({
//   // getCategories: () => {getCategories(dispatch)},
//   // addCategory: (category) => {addCategory(category, dispatch)},
//   setAddressDBChecks: (checks) => {setAddressDBChecks(checks, dispatch)},
// })

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps,
// )(AddressDBTable);
export default AddressDBTable;
